module.exports = __webpack_public_path__ + "static/8-mission1-tip-fa2afe0936b74bdc904764746d633766.png";